import { giphyCharcoal } from '@giphy/colors'
import { useContext, useMemo } from 'react'
import { ControlSize, Gradient } from 'types'
import { PortalTooltipContext } from 'ui'
import { CopilotContext } from '../context'
import Input from './input'
import { Button, Container, Dropdown, Icon, Options, Presets, Title } from './style'

type Props = {
    className?: string
    size: ControlSize
}

const CopilotDropdown = ({ className, size }: Props) => {
    const { activePresetId, disabled, hasChanges } = useContext(CopilotContext)

    const iconGradient: Gradient | undefined = useMemo(() => {
        if (hasChanges) {
            return 'red-yellow'
        }

        if (activePresetId) {
            return 'blue-green'
        }

        return
    }, [activePresetId, hasChanges])

    if (disabled) {
        return null
    }

    return (
        <PortalTooltipContext>
            <Container className={className}>
                <Title>
                    <Icon
                        color={iconGradient ? undefined : giphyCharcoal}
                        gradient={iconGradient}
                        height={20}
                        icon="flash"
                        width={20}
                    />
                    Presets
                </Title>
                <Button size={size}>
                    <Dropdown>
                        <Input />
                        <Presets />
                        <Options />
                    </Dropdown>
                </Button>
            </Container>
        </PortalTooltipContext>
    )
}

export default CopilotDropdown
